import { Phone, Coffee, Plug, ListFilter } from 'lucide-react';
import clsx from 'clsx';
import type { ActivityFilterKind } from '@/lib/useActivityFeed';

const CHIPS: Array<{ key: ActivityFilterKind; label: string; Icon: typeof Phone }> = [
  { key: 'all', label: 'Hepsi', Icon: ListFilter },
  { key: 'call', label: 'Çağrılar', Icon: Phone },
  { key: 'queue', label: 'Kuyruk', Icon: Coffee },
  { key: 'status', label: 'Durum', Icon: Plug },
];

export function ActivityFilters({ value, onChange }: {
  value: ActivityFilterKind;
  onChange: (v: ActivityFilterKind) => void;
}) {
  return (
    <div className="inline-flex items-center gap-1 p-1 rounded-xl bg-slate-100/70 ring-1 ring-slate-200/60">
      {CHIPS.map((c) => {
        const active = value === c.key;
        return (
          <button
            key={c.key}
            type="button"
            onClick={() => onChange(c.key)}
            className={clsx(
              'flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-[12px] font-medium transition',
              active
                ? 'bg-surface text-slate-900 shadow-sm ring-1 ring-slate-200'
                : 'text-slate-600 hover:text-slate-900 hover:bg-surface/60',
            )}
          >
            <c.Icon size={13} className={active ? 'text-brand-500' : 'text-slate-400'} />
            {c.label}
          </button>
        );
      })}
    </div>
  );
}
